module.exports = __webpack_public_path__ + "img/techBatteryPack_EN.jpg";